export default "__VITE_ASSET__7caeaf3c__$_?nuxt_component=async__"